import React, {useContext} from 'react';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import './logout.css';
import {AuthContext} from "../helper/AuthContext";

const Logout: React.FC = () => {
    const { triggerLogout } = useContext(AuthContext);
    return (
        <div className='logout-container'>
            <Button onClick={triggerLogout} className='logout-btn'>
                <LogoutIcon />
            </Button>
        </div>
    );
};

export default Logout;
